import _ from "lodash";
import React from "react";
import classes from "./AssessmentLibraryEdit.scss";
import LibraryBody from "UnitPlans/components/LibraryCommonComponents/LibraryBody";
import UILabel from "UIComponents/UILabel";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { getUnitPlanDetailsFromCache } from "IBPlanner/modules/IBGraphqlHelpers";
import { getUnitPlanFieldResponseFilter } from "UnitPlans/modules/Utils";
import { getUnitPlanCentralRepoInputAndFilters } from "Courses/modules/utils";

class AssessmentLibraryEdit extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedType: _.get(props.options, "assessmentType", "le"),
      loading: false,
    };
  }

  onTabClicked = selectedType => {
    this.setState({ selectedType });
  };

  toggleLoading = value => {
    this.setState({ loading: value });
  };

  filterList = assessments => {
    const {
      state: { selectedType },
    } = this;
    return _.filter(assessments, item => {
      return _.get(item, "assessmentType.value") === selectedType;
    });
  };

  onCardClicked = ({ id, mode }) => {
    this.props.showModal({ id, mode });
  };

  onDuplicateClick = async (id, promptText) => {
    const {
      assessmentTypes,
      importAssessment,
      unitPlanId,
      organizationId,
      selectedCourseId,
      academicYearId,
    } = this.props;

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: organizationId,
      courseId: selectedCourseId,
      academicYearId,
    });

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const unitPlanDetails = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });
    //@kunal where is this used? in UI?
    const unitPlanAcademicYearsIds = _.map(
      _.get(unitPlanDetails, "academicYears", []),
      item => item.id
    );

    importAssessment({
      sourceAssessmentId: id,
      title: promptText,
      isCopy: true,
      groupType: this.props.groupType,
      assessmentTypes,
      academicYears: unitPlanAcademicYearsIds,
    });
  };

  handleDeleteAssessment = async id => {
    const { deleteAssessment, groupType, assessmentTypes } = this.props;
    this.toggleLoading(true);
    await deleteAssessment({
      assessmentId: id,
      groupType,
      assessmentTypes,
    });
    this.toggleLoading(false);
  };

  render() {
    const {
      props: {
        assessments,
        getPrintFile,
        resource,
        options: { nodes = [] } = {},
        t,
        readOnly,
        unitPlanId,
        size,
        groupType,
        curriculumType,
        assessmentTypeGroup,
        assessmentTypes,
        isLoading,
        isFilteredData,
        isDragEnabled,
        handleRightPane,
        onClose,
        testId,
      },
      state: { selectedType, loading },
    } = this;

    return (
      <div className={classes.container}>
        <UILabel
          label={this.props.label}
          subText={this.props.subText}
          labelComponent={this.props.labelComponent}
          labelStyle={this.props.labelStyle}
          labelContainerStyle={this.props.labelContainerStyle}
        />

        <div className={classes.assessmentList}>
          {/* <div className={classes.tabsContainer}>
            <AssessmentTypeTabs
              nodes={nodes}
              assessments={assessments}
              selectedType={selectedType}
              onTabClicked={this.onTabClicked}
            />
          </div> */}
          <LibraryBody
            isFilteredData={isFilteredData}
            size={size}
            list={assessments}
            createText={t("common:add_with_label", {
              label: t(_.get(resource, "labelWithoutCount", "")),
            })}
            curriculumType={curriculumType}
            onCardClicked={this.onCardClicked}
            onDuplicateClick={this.onDuplicateClick}
            onDeleteClick={this.handleDeleteAssessment}
            isLoading={isLoading}
            assessmentTypes={assessmentTypes}
            assessmentTypeGroup={assessmentTypeGroup}
            onPrintClick={id => getPrintFile({ id: id, type: "assessment" })}
            label={t(_.get(resource, "labelWithoutCount", ""))}
            readOnly={readOnly}
            groupType={groupType}
            unitPlanId={unitPlanId}
            isDragEnabled={isDragEnabled}
            handleRightPane={handleRightPane}
            testId={testId}
            onClose={onClose}
          />
          {loading ? <FullScreenLoader /> : null}
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: "common" })(AssessmentLibraryEdit);
